export default __webpack_public_path__ + "static/media/DNo.35-3.a917c53a.jpg";